import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { fiatWalletsKeys } from '../fiatWalletsQueryKeys'
import { getFiatWallets } from '../fiatWalletsEndpoints'
import type { GetFiatWalletsParams } from '../../types/walletTypes'

export function useFiatWalletsQuery(filters: MaybeRefOrGetter<Partial<GetFiatWalletsParams>>) {
  return useQuery({
    queryKey: () => fiatWalletsKeys.list(toValue(filters)),
    queryFn: () =>
      getFiatWallets({
        page: 1,
        limit: 10,
        ...toValue(filters),
      }),
  })
}
